import { render, staticRenderFns } from "./SiteGroups.vue?vue&type=template&id=3d2f3030&scoped=true&"
import script from "./SiteGroups.vue?vue&type=script&lang=ts&"
export * from "./SiteGroups.vue?vue&type=script&lang=ts&"
import style0 from "./SiteGroups.vue?vue&type=style&index=0&id=3d2f3030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2f3030",
  null
  
)

export default component.exports